import React from 'react';
import { ModalContextType, ModalType, useModalContext } from 'src/hooks/useModal';
import { ScrollModal } from '../../../components/primitives/ScrollModal';
import { PositionModalWrapper } from '../FlowCommons/PositionModalWrapper';
import { AutoRebalanceModalContent } from './AutoRebalanceModalContent';

export const AutoRebalanceModal = () => {
  const { type, args, close } = useModalContext() as ModalContextType<{
    positionAddress: string;
  }>;

  return (
    <ScrollModal open={type === ModalType.AutoRebalance} setOpen={close}>
      <PositionModalWrapper
        positionAddress={args.positionAddress}
        modernStyle={true}
      >
        {(params) => <AutoRebalanceModalContent {...params} />}
      </PositionModalWrapper>
    </ScrollModal>
  );
};
